var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-samplecloth-cboxcontents" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.chosenItems, function(choice, index) {
        return [
          _c("div", { key: index, staticClass: "form-samplecloth__checkv2" }, [
            _c("div", { staticClass: "form-samplecloth__checkv2-pho" }, [
              _c("picture", [
                _c("img", { attrs: { src: choice.url, alt: "" } })
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "form-samplecloth__checkv2-text" }, [
              _vm._v(_vm._s(choice.name))
            ]),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "cloth_names[]" },
              domProps: { value: choice.name }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "form-samplecloth__check__btn" }, [
              _c(
                "button",
                {
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.choices.splice(index, 1)
                    }
                  }
                },
                [_vm._v("削除")]
              )
            ])
          ])
        ]
      }),
      _vm._v(" "),
      _vm.choices.length !== 0
        ? _c("div", { staticClass: "form-samplecloth__btn" }, [
            _c(
              "button",
              {
                staticClass: "js-samplecloth",
                attrs: { type: "button", href: "#inline-content" }
              },
              [_vm._v("生地を選ぶ")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cloth-colorbox", attrs: { id: "inline-content" } },
        [
          _c("section", { staticClass: "cloth-colorbox__container" }, [
            _c("h2", { staticClass: "cloth-colorbox__title" }, [
              _vm._v("生地一覧")
            ]),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "cloth-colorbox__table" },
              [
                _vm._l(_vm.clothes, function(cloth, clothIndex) {
                  return [
                    _c("tr", { key: clothIndex }, [
                      _c("th", [
                        _c("dl", [
                          _c("dt", [_vm._v(_vm._s(cloth.category))]),
                          _vm._v(" "),
                          _c("dd", [
                            _c("span", [_vm._v("素材：")]),
                            _c("span", {
                              domProps: { innerHTML: _vm._s(cloth.material) }
                            })
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "ul",
                          { staticClass: "cloth-colorbox__table-colorlist" },
                          [
                            _vm._l(cloth.items, function(color, colorIndex) {
                              return [
                                _c(
                                  "li",
                                  {
                                    key: color.url,
                                    staticClass:
                                      "cloth-colorbox__table-colorlist__item"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.choices,
                                          expression: "choices"
                                        }
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        id:
                                          "colorlist__item" +
                                          clothIndex +
                                          "-" +
                                          colorIndex
                                      },
                                      domProps: {
                                        value: {
                                          name: cloth.category + color.name,
                                          url: color.url
                                        },
                                        checked: Array.isArray(_vm.choices)
                                          ? _vm._i(_vm.choices, {
                                              name: cloth.category + color.name,
                                              url: color.url
                                            }) > -1
                                          : _vm.choices
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.choices,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = {
                                                name:
                                                  cloth.category + color.name,
                                                url: color.url
                                              },
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.choices = $$a.concat([
                                                  $$v
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.choices = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.choices = $$c
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for:
                                            "colorlist__item" +
                                            clothIndex +
                                            "-" +
                                            colorIndex
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cloth-colorbox__table-colorlist__item__pho"
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: color.url,
                                                alt: cloth.category + color.name
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("p", [_vm._v(_vm._s(color.name))]),
                                        _vm._v(" "),
                                        color.note
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "cloth-colorbox__table-colorlist__item__note"
                                              },
                                              [_vm._v(_vm._s(color.note))]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ])
                    ])
                  ]
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cloth-colorbox__btn" }, [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0)", id: "addClothes" },
                on: {
                  click: function($event) {
                    return _vm.addClothes()
                  }
                }
              },
              [_vm._v("チェックした生地を追加する")]
            )
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-samplecloth__btn" }, [
      _c(
        "button",
        {
          staticClass: "js-samplecloth",
          attrs: { type: "button", href: "#inline-content" }
        },
        [_vm._v("生地を選ぶ")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }